<app-loader *ngIf="isDisabled || isDisabledG"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Expense {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}
                                            - {{DetailData.DesignationName}}</label><br />
                                        <!-- <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>

                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Report
                                        Name</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ReportName}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Expense
                                        Type</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ExpenseType}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Expense
                                        Duration</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ExpenseDuration}}</label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Description</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.Description}}</label>
                                </div>
                            </div>
                            <div class="row" *ngIf="DetailData.ExpenseType == 'Outstation'">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Expense
                                        Total</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ExpenseTotal}}</label>
                                </div>
                            </div>
                            <div class="row" *ngIf="DetailData.ExpenseType == 'Outstation'">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Advance
                                        Amount</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.AdvanceAmount}}</label>
                                </div>
                            </div>
                            <div class="row" *ngIf="DetailData.ExpenseType == 'Outstation'">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Balance
                                        Amount</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.BalanceAmount}}</label>
                                </div>
                            </div>
                            <!-- <div class="row" *ngIf="DetailData.ExpenseType == 'Outstation'">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">ApprovedAmount</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ExpenseTotal}}</label>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div>
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row g-0">
            <div class="col"></div>
            <div class="col-auto">
                <span style="text-align-last: end;" class="px-3 badge success">Approve Amount : {{calTotal()}}</span>
            </div>
        </div> -->
        <div class="row g-0 p-2">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th>ExpenseDate</th>
                        <th>Category</th>
                        <th>Description</th>
                        <th>Attachment</th>
                        <th>Amount</th>
                        <th>ApprovedAmount</th>
                        <th>Rate</th>
                        <th>Kilometers</th>
                        <th>From</th>
                        <th>To</th>
                        <!-- <th>Class</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['ExpenseDate']}}</div>
                        </td>
                        <td style="width: 120px;">
                            <div style="width: 120px;">{{TableData['Expense/Category']}}</div>
                        </td>
                        <td style="width: 200px;">
                            <div style="width: 200px;">{{TableData['Description']}}</div>
                        </td>
                        <td class="attachmentThumbTD">
                            <app-thumbnail-attachment
                                *ngIf="TableData['Attachment'] != null && TableData['Attachment'] != ''"
                                [attachmentUrl]="TableData['Attachment']">
                            </app-thumbnail-attachment>
                        </td>
                        <td style="width: 80px;text-align:end">
                            <div style="width: 80px;">{{TableData['ExpenseAmount']}}</div>
                        </td>
                        <td style="width: 80px;text-align:end">
                            <div style="width: 110px;">
                                <input
                                    *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                                    (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)"
                                    type="text" class="form-control" placeholder="Ex. 15000" name="ApprovedAmount{{i}}"
                                    [(ngModel)]="TableData['ApprovedAmount']" #ApprovedAmount="ngModel" maxlength="5"
                                    pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(TableData['ApprovedAmount']))"
                                    (keyup)="common.NumberOnly($event,common.allowDot(TableData['ApprovedAmount']))"
                                    style="padding: 0 0.4rem;" required>

                                <div
                                    *ngIf="!((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                                    (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1))">
                                    {{TableData['ApprovedAmount']}}</div>
                            </div>
                        </td>
                        <td style="width: 50px;text-align:end">
                            <div style="width: 50px;">{{TableData['Rate']}}</div>
                        </td>
                        <td style="width: 70px;text-align:end">
                            <div style="width: 70px;">{{TableData['Kilometers']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['FromLocation']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['ToLocation']}}</div>
                        </td>
                        <!-- <td style="width: 120px;">
                            <div style="width: 120px;">{{TableData['ClassName']}}</div>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row" style="align-items:center">
            <div class="col-auto me-1 p-0">
                <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image class="userImage"
                    [src]="this.common.PhotoLink(this.DetailData.Photo,false)" />
                <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''" class="initial-image">
                    <div class="image">
                        {{common.getInitial(DetailData.EmployeeName)}}
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-auto">
                        <label class="form-label"
                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                        <label class="form-label"
                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}
                            - {{DetailData.DesignationName}}</label>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary" [disabled]="isDisabled">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>Request Amount :
                    {{calRequestAmountTotal().toFixed(2) }}</button>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-success"
                    [disabled]="isDisabled || common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected'">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>Approve Amount :
                    {{calTotal().toFixed(2)}}</button>
            </div>
            <div class="col-auto" style="align-content:center">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                            class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>
                    <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                        class="btn btn-danger" [disabled]="isDisabled"
                        (click)="ApprovalMatrixRequestProcess('Reject')"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Reject':'Loading...'}}</button>

                    <button *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[0]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)" type="button"
                        class="btn btn-success" [disabled]="isDisabled"
                        (click)="ApprovalMatrixRequestProcess('Approve')"><i class="bi bi-check2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Approve':'Loading...'}}</button>

                </div>
            </div>
        </div>
    </div>
</div>